import React from 'react';
import { Col, Row } from 'reactstrap';
import { ExpertiseDetailProps } from '../../../constants/interface/interface';

const ExpertiseDetail = ({ image, paragraphs, imageOnLeft = false }: ExpertiseDetailProps) => {
  const imageContent = (
    <Col
      lg="6"
      md="12"
      className={`expertise-detail-image `}
      data-aos={imageOnLeft ? 'fade-right' : 'fade-left'}
    >
      <img src={image} alt="Expertise" />
    </Col>
  );

  const textContent = (
    <Col
      lg="6"
      md="12"
      className="expertise-detail-content"
      data-aos={imageOnLeft ? 'fade-left' : 'fade-right'}
    >
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </Col>
  );

  return (
    <Row className={`expertise-detail ${imageOnLeft ? 'image-left' : ''}`}>
      {imageOnLeft ? [imageContent, textContent] : [textContent, imageContent]}
    </Row>
  );
};

export default ExpertiseDetail;
